import { css } from 'styled-components';

const styles = {
  breadcrumb: () => css`
    margin: ${({ theme }) => theme.spacing.xs}px 0;
  `,
  title: () => css`
    margin: ${({ theme }) => theme.spacing.xs}px 0 ${({ theme }) => theme.spacing.sm}px;

    p {
      display: block;
      font-weight: 100;
      margin: ${({ theme }) => theme.spacing.md}px 0;
    }
  `,
  content: () => css`
    .section-title {
      margin-bottom: ${({ theme }) => theme.spacing.xs}px;
    }
  `,
  toolbar: () => css`
    margin: ${({ theme }) => theme.spacing.xs}px 0 ${({ theme }) => theme.spacing.sm}px;
  `,
};

export default styles;
